<mat-form-field *ngIf="categories">
    <mat-label>{{ 'select-service' | translate }}</mat-label>
    <mat-select [(value)]="selectedCategoryId" (selectionChange)="setCategoryId()">
        <mat-option *ngFor="let category of categories" [value]="category.id">{{ getCategoryName(category) }}
        </mat-option>
    </mat-select>
</mat-form-field>